export default __webpack_public_path__ + "static/media/Necklace of Thousand Souls.19ab84a1.jpg";